module.exports = __webpack_public_path__ + "img/subject_banner6.63e9cd9d.png";